import { Component, OnInit } from '@angular/core';
import { DialogComponent } from "../dialog/dialog.component";
import { DialogService } from "../dialog/dialog.service";

export interface ConfirmModelPurchaseItem {
  title: string;
  data: any;
}
@Component({
  selector: 'app-item-master',
  templateUrl: './item-master.component.html',
  styleUrls: ['./item-master.component.css']
})

export class ItemMasterComponent extends DialogComponent<ConfirmModelPurchaseItem, boolean> implements ConfirmModelPurchaseItem, OnInit {

  Barcode: string;
  data: any;
  title: string;
  show: boolean = false;
  isLoaded: boolean = false;
  constructor(dialogService: DialogService) {
    super(dialogService);
    this.isLoaded = true;
  }
  ngOnInit() {
    this.Barcode = this.data;
    this.show = true;
    // if (!this.data) {
    //   this.close();
    // } else {
    //this.isLoaded = true;
    // }

  }


}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/item-master/item-master.component.ts